import { assignSafe } from '@summit/core';
import { v4 as uuid } from 'uuid';

export class SummitIdObject {
  [x: string]: unknown;
  id: string | number | null;

  constructor(jsonData?: Partial<SummitIdObject>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
    if (this.id === '') this.id = null;
    this.id ??= uuid();
  }
}
